import { cloneDeep } from "lodash";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
export const addMultipleViewForm = () => (args) => {
    const viewForm = args?.context.widgetState?.viewForm ?? ChartSelectValueFormatKind[args?.context.componentProps?.userSettings?.viewForm ?? ChartSelectValueFormatKind.amount];
    if (viewForm && viewForm === ChartSelectValueFormatKind.multiple) {
        const customResult = cloneDeep(args.context.staticData.customResult) ?? [];
        const first = customResult.shift();
        customResult.forEach((result) => {
            const newResultY = first.y ? result.y / first.y : null;
            result.y = newResultY;
            if (result.isSum && result.y === null) {
                result.isSum = false;
            }
        });
        first.y = first.y ? 1 : null;
        customResult.unshift(first);
        args.context.staticData.customResult = customResult;
    }
};
